export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Wip 3-2_07.90e6e781.jpg";